function Table(props){
    return(
        <table  className="min-w-full">
            {props.children}
        </table>
    )
}


export default Table